import { useEffect, useState } from "react"
import { getStockStatus } from "./request";
import { AppState } from "../../../state/store";

export const useGetStockStatus = (
	addExistsInStock: Function,   
	handleError: (error: Error) => any
) => {
  const [ registration, setRegistration ] = useState("");
  const [ existsInStock, setExistsInStock ] = useState(false);
  const [ error, setError ] = useState<any>();
  
  useEffect(() => {
		if (registration !== "") {
	  	getStockStatus(registration)
			.then((response) => {
				if (response.status === 200) {
					addExistsInStock(true)
					setRegistration("")
				} else if (response.status === 404) {
					addExistsInStock(false)
				} else {
					setError("Something went wrong");
				}
			})
			.catch (() => {
				setError(handleError);
			})
		}
	
	// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registration]);
  
  return (state: AppState) => {
		setRegistration(state.registration)
		setExistsInStock(existsInStock)
		setError(error)
  };
}